import { Component } from '@angular/core';

@Component({
    selector: 'app-team',
    templateUrl: './team.component.html',
    styleUrls: ['./team.component.scss']
})
export class TeamComponent {
    public teamModel: Array<any> = [
        {
            imageUrl: 'assets/images/press/pablo-ceo',
            name: 'Pablo Reyes',
            description: 'Chief Executive Officer (CEO)',
            imageSettings: {
                width: 454,
                height: 428
            }
        },
        {
            imageUrl: 'assets/images/press/lucas-coo',
            name: 'Lucas Rojo',
            description: 'Chief Operating Officer (COO)',
            imageSettings: {
                width: 454,
                height: 428
            }
        }
    ];
}
